export default __webpack_public_path__ + "static/media/reverseIceCracked.148529f5.svg";